// This file is AUTOGENERATED, do not edit it manually!!!

export const koPeopleTemplates = {
    nomatch_text: 'Lo sentimos, no se encontró nada',
    roles: 'Roles',
    teams: 'Equipos',
    users: 'Usuarios',
};
